import { ActionType } from 'typesafe-actions';

import { IAnalyticsData } from 'APIPackage/AnalyticsModule/interfaces/IAnalyticsData';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';

import * as actions from '../actions/analyticsActions';
import { AnalyticsActionsEnum } from '../enums/AnalyticsActionsEnum';
import { IAnalyticsFilter } from '../interfaces/IAnalyticsFilter';

export type AnalyticsAction = ActionType<typeof actions>;
export interface IAnalyticsState {
  data: IAnalyticsData[];
  filter: IAnalyticsFilter;
  knmData: IKnmRaw[];
  knmFilter: IAnalyticsFilter;
  knmOrder: string | null;
  knmPage: number;
  knmPageCount: number;
  knmTotalCount: number;
}

const initialState: IAnalyticsState = {
  data: [],
  filter: {
    includeChildProsec: true,
  },
  knmData: [],
  knmFilter: {
    includeChildProsec: true,
  },
  knmOrder: null,
  knmPage: 0,
  knmPageCount: 0,
  knmTotalCount: 0,
};

export function analyticsReducer(state: IAnalyticsState = initialState, action: AnalyticsAction) {
  switch (action.type) {
    case AnalyticsActionsEnum.ANALYTICS_SET_DATA: {
      const newState: IAnalyticsState = {
        ...state,
        data: action.payload.data,
      };

      return newState;
    }
    case AnalyticsActionsEnum.ANALYTICS_SET_FILTER: {
      const newState: IAnalyticsState = {
        ...state,
        filter: action.payload.filter,
      };

      return newState;
    }
    case AnalyticsActionsEnum.ANALYTICS_KNM_SET_DATA: {
      const { data: knmData, page: knmPage, totalCount: knmTotalCount, pageCount: knmPageCount } = action.payload;
      const newState: IAnalyticsState = {
        ...state,
        knmData,
        knmPage,
        knmTotalCount,
        knmPageCount,
      };

      return newState;
    }
    case AnalyticsActionsEnum.ANALYTICS_KNM_SET_FILTER: {
      const newState: IAnalyticsState = {
        ...state,
        knmFilter: action.payload.filter,
      };

      return newState;
    }
    case AnalyticsActionsEnum.ANALYTICS_KNM_SET_ORDER: {
      const newState: IAnalyticsState = {
        ...state,
        knmOrder: action.payload.order,
      };

      return newState;
    }
    default:
      return state;
  }
}
